import { memo } from "react";
import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const DocumentIcon = (props: IconWrapperProps) => (
  <IconWrapper viewBox="0 0 24 24" {...props}>
    <path
      fill="#FFF"
      fillOpacity="0"
      d="M0 0H24V24H0z"
      transform="translate(-1132 -2104) translate(-.288 128) translate(1108.288 119) translate(0 1416) translate(24 24) translate(0 195) translate(0 220) translate(0 2)"
    />
    <path
      fill="#666869"
      d="M2 0v24h20V7l-7-7H2zm2 2.001h9V9h7v13.001H4v-20zm11 .828L19.172 7H15V2.829zM6 14h12.001v-2H6v2zm0 4h12.001v-2H6v2z"
      transform="translate(-1132 -2104) translate(-.288 128) translate(1108.288 119) translate(0 1416) translate(24 24) translate(0 195) translate(0 220) translate(0 2)"
    />
  </IconWrapper>
);

export default memo(DocumentIcon);
